var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysLinkedin = function SvgSysLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0077b5",
    d: "M12 24A12 12 0 0 1 3.515 3.515a12 12 0 1 1 16.971 16.97A11.922 11.922 0 0 1 12 24Zm2.074-12.51c.738 0 1.128.524 1.128 1.515v3.585h2.227v-3.842c0-1.888-.958-3.015-2.564-3.015a2.225 2.225 0 0 0-2.007 1.105V9.89h-2.227c.026.572 0 5.661 0 6.675v.024h2.227v-3.741a1.566 1.566 0 0 1 .073-.544 1.242 1.242 0 0 1 1.143-.814Zm-6.9-1.6v6.7H9.4v-6.7ZM8.3 6.66a1.161 1.161 0 1 0-.03 2.315h.014A1.161 1.161 0 1 0 8.3 6.66Z",
    "data-name": "Subtra\\xE7\\xE3o 26"
  })));
};
export default SvgSysLinkedin;